export const idlFactory = ({ IDL }) => {
  const RequestPolicyRule = IDL.Rec();
  const AssetMetadata = IDL.Record({ 'key' : IDL.Text, 'value' : IDL.Text });
  const AddAssetInput = IDL.Record({
    'decimals' : IDL.Nat32,
    'standards' : IDL.Vec(IDL.Text),
    'metadata' : IDL.Vec(AssetMetadata),
    'name' : IDL.Text,
    'blockchain' : IDL.Text,
    'symbol' : IDL.Text,
  });
  const Result = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text });
  const ExternalCanisterValidationMethodInput = IDL.Record({
    'arg' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'method_name' : IDL.Text,
  });
  const ExternalCanisterCallerMethodCallInput = IDL.Record({
    'arg' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'validation_method' : IDL.Opt(ExternalCanisterValidationMethodInput),
    'cycles' : IDL.Opt(IDL.Nat),
    'method_name' : IDL.Text,
  });
  const RequestCallerPrivilegesDTO = IDL.Record({
    'id' : IDL.Text,
    'can_approve' : IDL.Bool,
  });
  const RequestStatusDTO = IDL.Variant({
    'Failed' : IDL.Record({ 'reason' : IDL.Opt(IDL.Text) }),
    'Approved' : IDL.Null,
    'Rejected' : IDL.Null,
    'Scheduled' : IDL.Record({ 'scheduled_at' : IDL.Text }),
    'Cancelled' : IDL.Record({ 'reason' : IDL.Opt(IDL.Text) }),
    'Processing' : IDL.Record({ 'started_at' : IDL.Text }),
    'Created' : IDL.Null,
    'Completed' : IDL.Record({ 'completed_at' : IDL.Text }),
  });
  const RequestDTO = IDL.Record({
    'id' : IDL.Text,
    'status' : RequestStatusDTO,
    'title' : IDL.Text,
  });
  const RequestAdditionalInfoDTO = IDL.Record({
    'id' : IDL.Text,
    'requester_name' : IDL.Text,
  });
  const SubmitRequestResponse = IDL.Record({
    'privileges' : RequestCallerPrivilegesDTO,
    'request' : RequestDTO,
    'additional_info' : RequestAdditionalInfoDTO,
  });
  const Error_1 = IDL.Record({
    'code' : IDL.Text,
    'message' : IDL.Opt(IDL.Text),
    'details' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
  });
  const CreateRequestResult = IDL.Variant({
    'Ok' : SubmitRequestResponse,
    'Err' : Error_1,
  });
  const Result_1 = IDL.Variant({
    'Ok' : CreateRequestResult,
    'Err' : IDL.Text,
  });
  const ExternalCanisterState = IDL.Variant({
    'Active' : IDL.Null,
    'Archived' : IDL.Null,
  });
  const CanisterInstallMode = IDL.Variant({
    'reinstall' : IDL.Null,
    'upgrade' : IDL.Null,
    'install' : IDL.Null,
  });
  const UpgradeExternalCanisterInput = IDL.Record({
    'arg' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'wasm_module' : IDL.Vec(IDL.Nat8),
    'mode' : CanisterInstallMode,
  });
  const ExternalCanisterSettingsInput = IDL.Record({
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Opt(IDL.Text),
    'labels' : IDL.Opt(IDL.Vec(IDL.Text)),
    'description' : IDL.Opt(IDL.Text),
  });
  const LogVisibility = IDL.Variant({
    'controllers' : IDL.Null,
    'public' : IDL.Null,
  });
  const NativeCanisterSettingsInput = IDL.Record({
    'freezing_threshold' : IDL.Opt(IDL.Nat),
    'controllers' : IDL.Opt(IDL.Vec(IDL.Principal)),
    'reserved_cycles_limit' : IDL.Opt(IDL.Nat),
    'log_visibility' : IDL.Opt(LogVisibility),
    'wasm_memory_limit' : IDL.Opt(IDL.Nat),
    'memory_allocation' : IDL.Opt(IDL.Nat),
    'compute_allocation' : IDL.Opt(IDL.Nat),
  });
  const ChangeExternalCanisterKind = IDL.Variant({
    'State' : ExternalCanisterState,
    'Upgrade' : UpgradeExternalCanisterInput,
    'Settings' : ExternalCanisterSettingsInput,
    'NativeSettings' : NativeCanisterSettingsInput,
  });
  const ChangeExternalCanisterOperationInput = IDL.Record({
    'kind' : ChangeExternalCanisterKind,
    'external_canister_id' : IDL.Text,
  });
  const CheckStatus = IDL.Variant({
    'Error' : IDL.Null,
    'Fail' : IDL.Null,
    'Pass' : IDL.Null,
    'Warn' : IDL.Null,
  });
  const RelatedPermission = IDL.Record({
    'groups' : IDL.Vec(IDL.Text),
    'resource_type' : IDL.Text,
    'resource_id' : IDL.Opt(IDL.Text),
  });
  const Severity = IDL.Variant({
    'Low' : IDL.Null,
    'High' : IDL.Null,
    'Medium' : IDL.Null,
    'None' : IDL.Null,
    'Critical' : IDL.Null,
  });
  const SecurityCheck = IDL.Record({
    'status' : CheckStatus,
    'related_permissions' : IDL.Opt(IDL.Vec(RelatedPermission)),
    'name' : IDL.Text,
    'message' : IDL.Text,
    'details' : IDL.Opt(IDL.Text),
    'category' : IDL.Text,
    'severity' : IDL.Opt(Severity),
    'recommendation' : IDL.Opt(IDL.Text),
  });
  const Result_2 = IDL.Variant({
    'Ok' : IDL.Vec(SecurityCheck),
    'Err' : IDL.Text,
  });
  const BackendStatusCheck = IDL.Record({
    'backend_principal' : IDL.Principal,
    'instructions' : IDL.Opt(IDL.Vec(IDL.Text)),
    'error' : IDL.Opt(IDL.Text),
    'station_id' : IDL.Principal,
    'is_member' : IDL.Bool,
  });
  const Result_3 = IDL.Variant({ 'Ok' : BackendStatusCheck, 'Err' : IDL.Text });
  const AuthScope = IDL.Variant({
    'Authenticated' : IDL.Null,
    'Public' : IDL.Null,
    'Restricted' : IDL.Null,
  });
  const Allow = IDL.Record({
    'user_groups' : IDL.Vec(IDL.Text),
    'auth_scope' : AuthScope,
    'users' : IDL.Vec(IDL.Text),
  });
  const ExternalCanisterQuorumValidationMethod = IDL.Record({
    'min_approvers' : IDL.Nat16,
  });
  const ExternalCanisterValidationMethodType = IDL.Variant({
    'No' : IDL.Null,
    'Quorum' : ExternalCanisterQuorumValidationMethod,
  });
  const ExternalCanisterCallPermission = IDL.Record({
    'execution_method' : IDL.Text,
    'allow' : Allow,
    'validation_method' : ExternalCanisterValidationMethodType,
  });
  const ExternalCanisterPermissions = IDL.Record({
    'calls' : IDL.Vec(ExternalCanisterCallPermission),
    'read' : Allow,
    'change' : Allow,
  });
  const UserSpecifier = IDL.Variant({
    'Id' : IDL.Vec(IDL.Text),
    'Any' : IDL.Null,
    'Group' : IDL.Vec(IDL.Text),
  });
  const Quorum = IDL.Record({
    'min_approved' : IDL.Nat16,
    'approvers' : UserSpecifier,
  });
  const MetadataItem = IDL.Record({ 'key' : IDL.Text, 'value' : IDL.Text });
  RequestPolicyRule.fill(
    IDL.Variant({
      'Not' : RequestPolicyRule,
      'Quorum' : Quorum,
      'AllowListed' : IDL.Null,
      'QuorumPercentage' : Quorum,
      'AutoApproved' : IDL.Null,
      'AllOf' : IDL.Vec(RequestPolicyRule),
      'AnyOf' : IDL.Vec(RequestPolicyRule),
      'AllowListedByMetadata' : MetadataItem,
      'NamedRule' : IDL.Text,
    })
  );
  const RequestPolicyWithAccount = IDL.Record({
    'rule' : RequestPolicyRule,
    'policy_id' : IDL.Opt(IDL.Text),
  });
  const ExternalCanisterRequestPolicies = IDL.Record({
    'calls' : IDL.Vec(RequestPolicyWithAccount),
    'change' : IDL.Vec(RequestPolicyWithAccount),
  });
  const ConfigureExternalCanisterKind = IDL.Variant({
    'CallPermission' : IDL.Vec(ExternalCanisterCallPermission),
    'Permissions' : ExternalCanisterPermissions,
    'RequestPolicies' : ExternalCanisterRequestPolicies,
  });
  const ConfigureExternalCanisterOperationInput = IDL.Record({
    'kind' : ConfigureExternalCanisterKind,
    'external_canister_id' : IDL.Text,
  });
  const RequestExecutionPlan = IDL.Variant({
    'Immediate' : IDL.Null,
    'Scheduled' : IDL.Record({ 'execution_time' : IDL.Text }),
  });
  const RemoveAddressBookEntryOperationInput = IDL.Record({
    'address_book_entry_id' : IDL.Text,
  });
  const ChangeMetadata = IDL.Variant({
    'OverrideSpecifiedBy' : IDL.Vec(MetadataItem),
    'RemoveKeys' : IDL.Vec(IDL.Text),
    'ReplaceAllBy' : IDL.Vec(MetadataItem),
  });
  const EditAddressBookEntryOperationInput = IDL.Record({
    'labels' : IDL.Opt(IDL.Vec(IDL.Text)),
    'change_metadata' : IDL.Opt(ChangeMetadata),
    'address_book_entry_id' : IDL.Text,
    'address_owner' : IDL.Opt(IDL.Text),
  });
  const AddAddressBookEntryOperationInput = IDL.Record({
    'metadata' : IDL.Vec(MetadataItem),
    'labels' : IDL.Vec(IDL.Text),
    'blockchain' : IDL.Text,
    'address' : IDL.Text,
    'address_format' : IDL.Text,
    'address_owner' : IDL.Text,
  });
  const RequestOperationInput = IDL.Variant({
    'RemoveAddressBookEntry' : RemoveAddressBookEntryOperationInput,
    'EditAddressBookEntry' : EditAddressBookEntryOperationInput,
    'AddAddressBookEntry' : AddAddressBookEntryOperationInput,
  });
  const CreateRequestInput = IDL.Record({
    'title' : IDL.Opt(IDL.Text),
    'execution_plan' : IDL.Opt(RequestExecutionPlan),
    'summary' : IDL.Opt(IDL.Text),
    'operation' : RequestOperationInput,
  });
  const Result_4 = IDL.Variant({ 'Ok' : IDL.Vec(IDL.Text), 'Err' : IDL.Text });
  const ResourceSpecifier = IDL.Variant({ 'Id' : IDL.Text, 'Any' : IDL.Null });
  const RequestAction = IDL.Variant({
    'List' : IDL.Null,
    'Read' : ResourceSpecifier,
  });
  const NotificationAction = IDL.Variant({
    'List' : IDL.Null,
    'Read' : IDL.Null,
    'MarkRead' : IDL.Null,
    'Delete' : IDL.Null,
    'Create' : IDL.Null,
    'Update' : IDL.Null,
  });
  const SystemAction = IDL.Variant({
    'Upgrade' : IDL.Null,
    'Restore' : IDL.Null,
    'ManageSystemInfo' : IDL.Null,
    'SystemInfo' : IDL.Null,
    'Capabilities' : IDL.Null,
  });
  const UserAction = IDL.Variant({
    'List' : IDL.Null,
    'Read' : ResourceSpecifier,
    'Create' : IDL.Null,
    'Update' : ResourceSpecifier,
  });
  const ExternalCanisterSpecifier = IDL.Variant({
    'Id' : IDL.Text,
    'Any' : IDL.Null,
    'Canister' : IDL.Principal,
  });
  const ExternalCanisterAction = IDL.Variant({
    'Call' : ExternalCanisterSpecifier,
    'Fund' : ExternalCanisterSpecifier,
    'List' : IDL.Null,
    'Read' : ExternalCanisterSpecifier,
    'Configure' : ExternalCanisterSpecifier,
    'Monitor' : ExternalCanisterSpecifier,
    'Create' : IDL.Null,
    'Change' : ExternalCanisterSpecifier,
    'Snapshot' : ExternalCanisterSpecifier,
  });
  const ResourceAction = IDL.Variant({
    'List' : IDL.Null,
    'Read' : ResourceSpecifier,
    'Remove' : ResourceSpecifier,
    'Delete' : ResourceSpecifier,
    'Create' : IDL.Null,
    'Transfer' : ResourceSpecifier,
    'Update' : ResourceSpecifier,
  });
  const PermissionAction = IDL.Variant({
    'Read' : IDL.Null,
    'Update' : IDL.Null,
  });
  const Resource = IDL.Variant({
    'Request' : RequestAction,
    'Notification' : NotificationAction,
    'System' : SystemAction,
    'User' : UserAction,
    'ExternalCanister' : ExternalCanisterAction,
    'Account' : ResourceAction,
    'AddressBook' : ResourceAction,
    'Asset' : ResourceAction,
    'NamedRule' : ResourceAction,
    'UserGroup' : ResourceAction,
    'Permission' : PermissionAction,
    'RequestPolicy' : ResourceAction,
  });
  const Result_5 = IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text });
  const SubnetSelection = IDL.Variant({
    'Subnet' : IDL.Record({ 'subnet_id' : IDL.Principal }),
  });
  const CreateExternalCanisterOptions = IDL.Record({
    'initial_cycles' : IDL.Opt(IDL.Nat),
    'subnet_selection' : IDL.Opt(SubnetSelection),
  });
  const CreateExternalCanisterKind = IDL.Variant({
    'AddExisting' : IDL.Record({ 'canister_id' : IDL.Principal }),
    'CreateNew' : CreateExternalCanisterOptions,
  });
  const CreateExternalCanisterOperationInput = IDL.Record({
    'permissions' : ExternalCanisterPermissions,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'kind' : CreateExternalCanisterKind,
    'name' : IDL.Text,
    'labels' : IDL.Vec(IDL.Text),
    'description' : IDL.Opt(IDL.Text),
    'request_policies' : ExternalCanisterRequestPolicies,
  });
  const AssetDetails = IDL.Record({
    'decimals' : IDL.Nat8,
    'name' : IDL.Text,
    'symbol' : IDL.Text,
  });
  const TransferDetails = IDL.Record({
    'to' : IDL.Text,
    'title' : IDL.Text,
    'from_account_id' : IDL.Text,
    'memo' : IDL.Opt(IDL.Text),
    'description' : IDL.Text,
    'amount' : IDL.Nat,
    'from_asset_id' : IDL.Text,
  });
  const OrbitOperation = IDL.Variant({
    'AddAsset' : IDL.Record({ 'asset' : AssetDetails }),
    'EditUser' : IDL.Record({
      'groups' : IDL.Vec(IDL.Text),
      'name' : IDL.Opt(IDL.Text),
      'user_id' : IDL.Text,
    }),
    'Transfer' : TransferDetails,
    'RemoveAdmin' : IDL.Record({
      'user_name' : IDL.Text,
      'user_id' : IDL.Text,
    }),
  });
  const ProposalError = IDL.Variant({
    'AlreadyVoted' : IDL.Nat64,
    'InvalidTransferDetails' : IDL.Text,
    'NotActive' : IDL.Null,
    'NotFound' : IDL.Nat64,
    'Custom' : IDL.Text,
    'NoStationLinked' : IDL.Principal,
    'IcCallFailed' : IDL.Record({ 'code' : IDL.Int32, 'message' : IDL.Text }),
    'OrbitError' : IDL.Record({
      'code' : IDL.Text,
      'message' : IDL.Text,
      'details' : IDL.Opt(IDL.Text),
    }),
    'ActiveProposalExists' : IDL.Null,
    'InsufficientVotingPowerToPropose' : IDL.Record({
      'required' : IDL.Nat64,
      'current' : IDL.Nat64,
    }),
    'ZeroVotingPower' : IDL.Null,
    'NoVotingPower' : IDL.Null,
    'Expired' : IDL.Null,
    'AuthRequired' : IDL.Null,
  });
  const Result_6 = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : ProposalError });
  const CreateAccountConfig = IDL.Record({
    'configs_request_policy' : IDL.Opt(RequestPolicyRule),
    'read_permission' : Allow,
    'configs_permission' : Allow,
    'metadata' : IDL.Vec(MetadataItem),
    'name' : IDL.Text,
    'transfer_request_policy' : IDL.Opt(RequestPolicyRule),
    'asset_ids' : IDL.Vec(IDL.Text),
    'transfer_permission' : Allow,
  });
  const CreateAccountResponse = IDL.Record({
    'request_id' : IDL.Text,
    'status' : IDL.Text,
    'auto_approved' : IDL.Bool,
    'error' : IDL.Opt(IDL.Text),
  });
  const Result_7 = IDL.Variant({
    'Ok' : CreateAccountResponse,
    'Err' : IDL.Text,
  });
  const AccountBalance = IDL.Record({
    'account_id' : IDL.Text,
    'decimals' : IDL.Nat32,
    'balance' : IDL.Nat,
    'last_update_timestamp' : IDL.Text,
    'query_state' : IDL.Text,
    'asset_id' : IDL.Text,
  });
  const Result_8 = IDL.Variant({
    'Ok' : IDL.Vec(IDL.Opt(AccountBalance)),
    'Err' : IDL.Text,
  });
  const FundExternalCanisterSendCyclesInput = IDL.Record({
    'cycles' : IDL.Nat,
  });
  const FundExternalCanisterKind = IDL.Variant({
    'Send' : FundExternalCanisterSendCyclesInput,
  });
  const FundExternalCanisterOperationInput = IDL.Record({
    'kind' : FundExternalCanisterKind,
    'external_canister_id' : IDL.Text,
  });
  const AssetBalanceInfo = IDL.Record({
    'decimals' : IDL.Nat32,
    'balance' : IDL.Nat64,
    'asset_id' : IDL.Text,
    'balance_formatted' : IDL.Text,
    'symbol' : IDL.Text,
  });
  const AccountAssetInfo = IDL.Record({
    'account_id' : IDL.Text,
    'assets' : IDL.Vec(AssetBalanceInfo),
    'account_name' : IDL.Text,
  });
  const Result_9 = IDL.Variant({ 'Ok' : AccountAssetInfo, 'Err' : IDL.Text });
  const Asset = IDL.Record({
    'id' : IDL.Text,
    'decimals' : IDL.Nat32,
    'standards' : IDL.Vec(IDL.Text),
    'metadata' : IDL.Vec(MetadataItem),
    'name' : IDL.Text,
    'blockchain' : IDL.Text,
    'symbol' : IDL.Text,
  });
  const AssetWithBalance = IDL.Record({
    'balance' : IDL.Opt(AccountBalance),
    'asset' : Asset,
  });
  const AccountAsset = IDL.Record({
    'balance' : IDL.Opt(AccountBalance),
    'asset_id' : IDL.Text,
  });
  const AccountAddress = IDL.Record({
    'address' : IDL.Text,
    'format' : IDL.Text,
  });
  const Account = IDL.Record({
    'id' : IDL.Text,
    'configs_request_policy' : IDL.Opt(RequestPolicyRule),
    'metadata' : IDL.Vec(MetadataItem),
    'name' : IDL.Text,
    'assets' : IDL.Vec(AccountAsset),
    'addresses' : IDL.Vec(AccountAddress),
    'transfer_request_policy' : IDL.Opt(RequestPolicyRule),
    'last_modification_timestamp' : IDL.Text,
  });
  const AccountWithAssets = IDL.Record({
    'assets' : IDL.Vec(AssetWithBalance),
    'account' : Account,
  });
  const Result_10 = IDL.Variant({ 'Ok' : AccountWithAssets, 'Err' : IDL.Text });
  const GetAddressBookEntryInput = IDL.Record({
    'address_book_entry_id' : IDL.Text,
  });
  const AddressBookEntryCallerPrivileges = IDL.Record({
    'id' : IDL.Text,
    'can_delete' : IDL.Bool,
    'can_edit' : IDL.Bool,
  });
  const AddressBookEntry = IDL.Record({
    'id' : IDL.Text,
    'metadata' : IDL.Vec(MetadataItem),
    'labels' : IDL.Vec(IDL.Text),
    'blockchain' : IDL.Text,
    'address' : IDL.Text,
    'last_modification_timestamp' : IDL.Text,
    'address_format' : IDL.Text,
    'address_owner' : IDL.Text,
  });
  const GetAddressBookEntryResult = IDL.Variant({
    'Ok' : IDL.Record({
      'privileges' : AddressBookEntryCallerPrivileges,
      'address_book_entry' : AddressBookEntry,
    }),
    'Err' : Error_1,
  });
  const AgreementSnapshot = IDL.Record({
    'updated_at' : IDL.Nat64,
    'token_id' : IDL.Principal,
    'data' : IDL.Text,
    'created_at' : IDL.Nat64,
    'version' : IDL.Nat32,
    'station_id' : IDL.Principal,
  });
  const Result_11 = IDL.Variant({ 'Ok' : AgreementSnapshot, 'Err' : IDL.Text });
  const VotingPowerEntry = IDL.Record({
    'user_principal' : IDL.Principal,
    'kong_locker_principal' : IDL.Principal,
    'voting_power' : IDL.Nat64,
    'equity_percentage' : IDL.Float64,
  });
  const AllVotingPowersResponse = IDL.Record({
    'total_holders' : IDL.Nat32,
    'entries' : IDL.Vec(VotingPowerEntry),
    'total_voting_power' : IDL.Nat64,
  });
  const Result_12 = IDL.Variant({
    'Ok' : AllVotingPowersResponse,
    'Err' : IDL.Text,
  });
  const ListAssetsResult = IDL.Variant({
    'Ok' : IDL.Record({ 'assets' : IDL.Vec(Asset) }),
    'Err' : Error_1,
  });
  const CanisterSnapshot = IDL.Record({
    'total_size' : IDL.Nat64,
    'taken_at_timestamp' : IDL.Text,
    'snapshot_id' : IDL.Text,
  });
  const CanisterSnapshotsResult = IDL.Variant({
    'Ok' : IDL.Vec(CanisterSnapshot),
    'Err' : Error_1,
  });
  const Result_13 = IDL.Variant({
    'Ok' : CanisterSnapshotsResult,
    'Err' : IDL.Text,
  });
  const CanisterStatusResponse = IDL.Record({
    'status' : IDL.Text,
    'memory_size' : IDL.Text,
    'cycles' : IDL.Text,
    'module_hash' : IDL.Opt(IDL.Text),
  });
  const Result_14 = IDL.Variant({
    'Ok' : CanisterStatusResponse,
    'Err' : IDL.Text,
  });
  const DaoOverviewStats = IDL.Record({
    'treasury_total_icp' : IDL.Nat64,
    'treasury_account_count' : IDL.Nat64,
    'active_proposal_count' : IDL.Nat64,
    'recent_proposal_count' : IDL.Nat64,
    'station_id' : IDL.Opt(IDL.Principal),
    'member_count' : IDL.Nat64,
    'station_name' : IDL.Opt(IDL.Text),
  });
  const Result_15 = IDL.Variant({ 'Ok' : DaoOverviewStats, 'Err' : IDL.Text });
  const VotingThresholds = IDL.Record({
    'transfer_funds' : IDL.Nat32,
    'change_permissions' : IDL.Nat32,
    'remove_members' : IDL.Nat32,
    'system_upgrades' : IDL.Nat32,
    'add_members' : IDL.Nat32,
  });
  const GovernanceStats = IDL.Record({
    'active_proposals' : IDL.Nat64,
    'rejected_proposals' : IDL.Nat64,
    'average_participation' : IDL.Nat32,
    'configured_thresholds' : IDL.Opt(VotingThresholds),
    'approved_proposals' : IDL.Nat64,
    'total_proposals' : IDL.Nat64,
  });
  const Result_16 = IDL.Variant({ 'Ok' : GovernanceStats, 'Err' : IDL.Text });
  const Result_17 = IDL.Variant({
    'Ok' : IDL.Vec(IDL.Principal),
    'Err' : IDL.Text,
  });
  const TokenInfo = IDL.Record({
    'chain' : IDL.Text,
    'canister_id' : IDL.Text,
    'symbol' : IDL.Text,
  });
  const Result_18 = IDL.Variant({
    'Ok' : IDL.Vec(TokenInfo),
    'Err' : IDL.Text,
  });
  const Result_19 = IDL.Variant({ 'Ok' : IDL.Nat64, 'Err' : IDL.Text });
  const ExternalCanisterCallerPrivileges = IDL.Record({
    'id' : IDL.Text,
    'can_change' : IDL.Bool,
    'canister_id' : IDL.Principal,
    'can_call' : IDL.Vec(IDL.Text),
    'can_fund' : IDL.Bool,
  });
  const MonitoringStrategy = IDL.Variant({
    'Always' : IDL.Null,
    'BelowThreshold' : IDL.Record({ 'min_cycles' : IDL.Nat }),
    'BelowEstimatedRuntime' : IDL.Record({ 'runtime_seconds' : IDL.Nat64 }),
  });
  const MonitoringConfig = IDL.Record({
    'strategy' : MonitoringStrategy,
    'funding_amount' : IDL.Nat,
  });
  const ExternalCanister = IDL.Record({
    'id' : IDL.Text,
    'permissions' : ExternalCanisterPermissions,
    'modified_at' : IDL.Opt(IDL.Text),
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'labels' : IDL.Vec(IDL.Text),
    'canister_id' : IDL.Principal,
    'description' : IDL.Opt(IDL.Text),
    'created_at' : IDL.Text,
    'request_policies' : ExternalCanisterRequestPolicies,
    'state' : ExternalCanisterState,
    'monitoring' : IDL.Opt(MonitoringConfig),
  });
  const GetExternalCanisterResult = IDL.Variant({
    'Ok' : IDL.Record({
      'privileges' : ExternalCanisterCallerPrivileges,
      'canister' : ExternalCanister,
    }),
    'Err' : Error_1,
  });
  const Result_20 = IDL.Variant({
    'Ok' : GetExternalCanisterResult,
    'Err' : IDL.Text,
  });
  const SimpleRequest = IDL.Record({
    'id' : IDL.Text,
    'status' : IDL.Text,
    'title' : IDL.Text,
  });
  const Result_21 = IDL.Variant({
    'Ok' : IDL.Vec(SimpleRequest),
    'Err' : IDL.Text,
  });
  const CycleObtainStrategyMinimal = IDL.Variant({
    'Disabled' : IDL.Null,
    'MintFromNativeToken' : IDL.Record({ 'account_id' : IDL.Text }),
    'WithdrawFromCyclesLedger' : IDL.Record({ 'account_id' : IDL.Text }),
  });
  const SystemInfoMinimal = IDL.Record({
    'name' : IDL.Text,
    'last_upgrade_timestamp' : IDL.Text,
    'raw_rand_successful' : IDL.Bool,
    'version' : IDL.Text,
    'cycles' : IDL.Nat64,
    'upgrader_id' : IDL.Principal,
    'cycle_obtain_strategy' : CycleObtainStrategyMinimal,
  });
  const SystemInfoResponseMinimal = IDL.Record({
    'system_info' : SystemInfoMinimal,
    'station_id' : IDL.Principal,
  });
  const Result_22 = IDL.Variant({
    'Ok' : SystemInfoResponseMinimal,
    'Err' : IDL.Text,
  });
  const OrbitRequestType = IDL.Variant({
    'RemoveAsset' : IDL.Null,
    'AddUserGroup' : IDL.Null,
    'EditPermission' : IDL.Null,
    'SnapshotExternalCanister' : IDL.Null,
    'PruneExternalCanister' : IDL.Null,
    'EditNamedRule' : IDL.Null,
    'ConfigureExternalCanister' : IDL.Null,
    'ChangeExternalCanister' : IDL.Null,
    'MonitorExternalCanister' : IDL.Null,
    'AddUser' : IDL.Null,
    'EditAsset' : IDL.Null,
    'EditUserGroup' : IDL.Null,
    'SetDisasterRecovery' : IDL.Null,
    'EditRequestPolicy' : IDL.Null,
    'RemoveRequestPolicy' : IDL.Null,
    'AddAsset' : IDL.Null,
    'SystemUpgrade' : IDL.Null,
    'RemoveAddressBookEntry' : IDL.Null,
    'SystemRestore' : IDL.Null,
    'CreateExternalCanister' : IDL.Null,
    'EditAddressBookEntry' : IDL.Null,
    'FundExternalCanister' : IDL.Null,
    'EditUser' : IDL.Null,
    'ManageSystemInfo' : IDL.Null,
    'Transfer' : IDL.Null,
    'EditAccount' : IDL.Null,
    'AddAddressBookEntry' : IDL.Null,
    'RemoveUser' : IDL.Null,
    'Other' : IDL.Text,
    'AddRequestPolicy' : IDL.Null,
    'RemoveNamedRule' : IDL.Null,
    'RemoveUserGroup' : IDL.Null,
    'CallExternalCanister' : IDL.Null,
    'AddNamedRule' : IDL.Null,
    'RestoreExternalCanister' : IDL.Null,
    'AddAccount' : IDL.Null,
  });
  const ProposalType = IDL.Variant({
    'Transfer' : IDL.Null,
    'OrbitRequest' : OrbitRequestType,
  });
  const ProposalType_1 = IDL.Variant({
    'RemoveMember' : IDL.Null,
    'ChangePermissions' : IDL.Null,
    'AddMember' : IDL.Null,
    'SystemUpgrade' : IDL.Null,
    'GeneralOperation' : IDL.Null,
    'TransferFunds' : IDL.Null,
  });
  const ProposalConfig = IDL.Record({
    'voting_period_seconds' : IDL.Nat64,
    'execution_delay_seconds' : IDL.Nat64,
    'required_threshold' : IDL.Nat32,
    'proposal_type' : ProposalType_1,
  });
  const Result_23 = IDL.Variant({ 'Ok' : ProposalConfig, 'Err' : IDL.Text });
  const IdListSpecifier = IDL.Variant({
    'Any' : IDL.Null,
    'Ids' : IDL.Vec(IDL.Text),
  });
  const RequestSpecifier = IDL.Variant({
    'RemoveAsset' : ResourceSpecifier,
    'AddUserGroup' : IDL.Null,
    'EditPermission' : ResourceSpecifier,
    'EditNamedRule' : ResourceSpecifier,
    'ChangeExternalCanister' : ResourceSpecifier,
    'AddUser' : IDL.Null,
    'EditAsset' : ResourceSpecifier,
    'EditUserGroup' : ResourceSpecifier,
    'SetDisasterRecovery' : IDL.Null,
    'EditRequestPolicy' : ResourceSpecifier,
    'RemoveRequestPolicy' : ResourceSpecifier,
    'AddAsset' : IDL.Null,
    'SystemUpgrade' : IDL.Null,
    'RemoveAddressBookEntry' : ResourceSpecifier,
    'CreateExternalCanister' : IDL.Null,
    'EditAddressBookEntry' : ResourceSpecifier,
    'FundExternalCanister' : ResourceSpecifier,
    'ChangeCanister' : IDL.Null,
    'EditUser' : ResourceSpecifier,
    'ManageSystemInfo' : IDL.Null,
    'Transfer' : IdListSpecifier,
    'EditAccount' : IdListSpecifier,
    'AddAddressBookEntry' : IDL.Null,
    'RemoveUser' : IDL.Null,
    'RemoveAccount' : IDL.Null,
    'AddRequestPolicy' : IDL.Null,
    'RemoveNamedRule' : ResourceSpecifier,
    'RemoveUserGroup' : ResourceSpecifier,
    'CallExternalCanister' : IDL.Principal,
    'AddNamedRule' : IDL.Null,
    'AddAccount' : IDL.Null,
  });
  const RequestPolicyInfo = IDL.Record({
    'rule' : RequestPolicyRule,
    'specifier' : RequestSpecifier,
    'operation' : IDL.Text,
    'approval_rule' : IDL.Text,
  });
  const RequestPoliciesDetails = IDL.Record({
    'auto_approved_count' : IDL.Nat64,
    'bypass_count' : IDL.Nat64,
    'total_count' : IDL.Nat64,
    'policies' : IDL.Vec(RequestPolicyInfo),
  });
  const Result_24 = IDL.Variant({
    'Ok' : RequestPoliciesDetails,
    'Err' : IDL.Text,
  });
  const Permission = IDL.Record({ 'resource' : Resource, 'allow' : Allow });
  const Result_25 = IDL.Variant({ 'Ok' : Permission, 'Err' : IDL.Text });
  const Result_26 = IDL.Variant({ 'Ok' : Account, 'Err' : IDL.Text });
  const AccountAssetWithBalance = IDL.Record({
    'balance' : AccountBalance,
    'asset_symbol' : IDL.Text,
    'asset_id' : IDL.Text,
  });
  const AccountMinimalWithBalances = IDL.Record({
    'id' : IDL.Text,
    'configs_request_policy' : IDL.Opt(RequestPolicyRule),
    'metadata' : IDL.Vec(MetadataItem),
    'name' : IDL.Text,
    'assets' : IDL.Vec(AccountAssetWithBalance),
    'addresses' : IDL.Vec(AccountAddress),
    'transfer_request_policy' : IDL.Opt(RequestPolicyRule),
    'last_modification_timestamp' : IDL.Text,
  });
  const Result_27 = IDL.Variant({
    'Ok' : IDL.Vec(AccountMinimalWithBalances),
    'Err' : IDL.Text,
  });
  const TreasuryAddressBookEntry = IDL.Record({
    'id' : IDL.Text,
    'name' : IDL.Text,
    'blockchain' : IDL.Text,
    'address' : IDL.Text,
    'purpose' : IDL.Opt(IDL.Text),
  });
  const AssetBalanceInfo_1 = IDL.Record({
    'decimals' : IDL.Nat32,
    'balance' : IDL.Text,
    'balance_formatted' : IDL.Text,
    'symbol' : IDL.Text,
  });
  const TreasuryAccountDetails = IDL.Record({
    'account_id' : IDL.Text,
    'can_transfer' : IDL.Bool,
    'assets' : IDL.Vec(AssetBalanceInfo_1),
    'config_policy' : IDL.Text,
    'transfer_policy' : IDL.Text,
    'addresses' : IDL.Vec(AccountAddress),
    'can_edit' : IDL.Bool,
    'account_name' : IDL.Text,
  });
  const TreasuryManagementData = IDL.Record({
    'address_book' : IDL.Vec(TreasuryAddressBookEntry),
    'accounts' : IDL.Vec(TreasuryAccountDetails),
    'backend_privileges_summary' : IDL.Text,
  });
  const Result_28 = IDL.Variant({
    'Ok' : TreasuryManagementData,
    'Err' : IDL.Text,
  });
  const OrbitApprovalSummary = IDL.Record({
    'status' : IDL.Text,
    'status_detail' : IDL.Opt(IDL.Text),
    'approver_id' : IDL.Text,
    'decided_at' : IDL.Text,
  });
  const OrbitRequestSummary = IDL.Record({
    'id' : IDL.Text,
    'status' : IDL.Text,
    'status_detail' : IDL.Opt(IDL.Text),
    'title' : IDL.Text,
    'expiration_dt' : IDL.Text,
    'created_at' : IDL.Text,
    'requested_by' : IDL.Text,
    'summary' : IDL.Opt(IDL.Text),
    'operation' : IDL.Opt(IDL.Text),
    'requester_name' : IDL.Opt(IDL.Text),
    'approvals' : IDL.Vec(OrbitApprovalSummary),
  });
  const Result_29 = IDL.Variant({
    'Ok' : IDL.Vec(OrbitRequestSummary),
    'Err' : IDL.Text,
  });
  const VotingPowerSource = IDL.Variant({
    'KongLocker' : IDL.Null,
    'Equity' : IDL.Null,
  });
  const VotingPowerResult = IDL.Record({
    'source' : VotingPowerSource,
    'voting_power' : IDL.Nat64,
  });
  const Result_30 = IDL.Variant({ 'Ok' : VotingPowerResult, 'Err' : IDL.Text });
  const Result_31 = IDL.Variant({ 'Ok' : VotingThresholds, 'Err' : IDL.Text });
  const Result_32 = IDL.Variant({ 'Ok' : IDL.Bool, 'Err' : IDL.Text });
  const PaginationInput = IDL.Record({
    'offset' : IDL.Opt(IDL.Nat64),
    'limit' : IDL.Opt(IDL.Nat64),
  });
  const ListAddressBookEntriesInput = IDL.Record({
    'ids' : IDL.Opt(IDL.Vec(IDL.Text)),
    'address_formats' : IDL.Opt(IDL.Vec(IDL.Text)),
    'labels' : IDL.Opt(IDL.Vec(IDL.Text)),
    'blockchain' : IDL.Opt(IDL.Text),
    'addresses' : IDL.Opt(IDL.Vec(IDL.Text)),
    'paginate' : IDL.Opt(PaginationInput),
    'search_term' : IDL.Opt(IDL.Text),
  });
  const ListAddressBookEntriesResponse = IDL.Record({
    'total' : IDL.Nat64,
    'privileges' : IDL.Vec(AddressBookEntryCallerPrivileges),
    'address_book_entries' : IDL.Vec(AddressBookEntry),
    'next_offset' : IDL.Opt(IDL.Nat64),
  });
  const ListAddressBookEntriesResult = IDL.Variant({
    'Ok' : ListAddressBookEntriesResponse,
    'Err' : Error_1,
  });
  const AccountCallerPrivileges = IDL.Record({
    'id' : IDL.Text,
    'can_transfer' : IDL.Bool,
    'can_edit' : IDL.Bool,
  });
  const AccountMinimal = IDL.Record({
    'id' : IDL.Text,
    'metadata' : IDL.Vec(MetadataItem),
    'name' : IDL.Text,
    'assets' : IDL.Vec(AccountAsset),
    'addresses' : IDL.Vec(AccountAddress),
    'last_modification_timestamp' : IDL.Text,
  });
  const ListAccountsResultMinimal = IDL.Variant({
    'Ok' : IDL.Record({
      'total' : IDL.Nat64,
      'privileges' : IDL.Vec(AccountCallerPrivileges),
      'accounts' : IDL.Vec(AccountMinimal),
    }),
    'Err' : Error_1,
  });
  const Result_33 = IDL.Variant({
    'Ok' : ListAccountsResultMinimal,
    'Err' : IDL.Text,
  });
  const PaginationInputMinimal = IDL.Record({
    'offset' : IDL.Nat64,
    'limit' : IDL.Nat16,
  });
  const ListExternalCanistersInputMinimal = IDL.Record({
    'states' : IDL.Vec(ExternalCanisterState),
    'canister_ids' : IDL.Vec(IDL.Principal),
    'labels' : IDL.Vec(IDL.Text),
    'paginate' : PaginationInputMinimal,
  });
  const ListExternalCanistersResult = IDL.Variant({
    'Ok' : IDL.Record({
      'total' : IDL.Nat64,
      'privileges' : IDL.Vec(ExternalCanisterCallerPrivileges),
      'canisters' : IDL.Vec(ExternalCanister),
      'next_offset' : IDL.Opt(IDL.Nat64),
    }),
    'Err' : Error_1,
  });
  const Result_34 = IDL.Variant({
    'Ok' : ListExternalCanistersResult,
    'Err' : IDL.Text,
  });
  const RequestStatusCode = IDL.Variant({
    'Failed' : IDL.Null,
    'Approved' : IDL.Null,
    'Rejected' : IDL.Null,
    'Scheduled' : IDL.Null,
    'Cancelled' : IDL.Null,
    'Processing' : IDL.Null,
    'Created' : IDL.Null,
    'Completed' : IDL.Null,
  });
  const PaginationInput_1 = IDL.Record({
    'offset' : IDL.Opt(IDL.Nat64),
    'limit' : IDL.Opt(IDL.Nat16),
  });
  const ListRequestsOperationType = IDL.Variant({
    'RemoveAsset' : IDL.Null,
    'AddUserGroup' : IDL.Null,
    'EditPermission' : IDL.Null,
    'SnapshotExternalCanister' : IDL.Opt(IDL.Principal),
    'PruneExternalCanister' : IDL.Opt(IDL.Principal),
    'EditNamedRule' : IDL.Null,
    'ConfigureExternalCanister' : IDL.Opt(IDL.Principal),
    'ChangeExternalCanister' : IDL.Opt(IDL.Principal),
    'MonitorExternalCanister' : IDL.Opt(IDL.Principal),
    'AddUser' : IDL.Null,
    'EditAsset' : IDL.Null,
    'EditUserGroup' : IDL.Null,
    'SetDisasterRecovery' : IDL.Null,
    'EditRequestPolicy' : IDL.Null,
    'RemoveRequestPolicy' : IDL.Null,
    'AddAsset' : IDL.Null,
    'SystemUpgrade' : IDL.Null,
    'RemoveAddressBookEntry' : IDL.Null,
    'SystemRestore' : IDL.Null,
    'CreateExternalCanister' : IDL.Null,
    'EditAddressBookEntry' : IDL.Null,
    'FundExternalCanister' : IDL.Opt(IDL.Principal),
    'EditUser' : IDL.Null,
    'ManageSystemInfo' : IDL.Null,
    'Transfer' : IDL.Opt(IDL.Text),
    'EditAccount' : IDL.Null,
    'AddAddressBookEntry' : IDL.Null,
    'AddRequestPolicy' : IDL.Null,
    'RemoveNamedRule' : IDL.Null,
    'RemoveUserGroup' : IDL.Null,
    'CallExternalCanister' : IDL.Opt(IDL.Principal),
    'AddNamedRule' : IDL.Null,
    'RestoreExternalCanister' : IDL.Opt(IDL.Principal),
    'AddAccount' : IDL.Null,
  });
  const ListRequestsInput = IDL.Record({
    'sort_by' : IDL.Null,
    'deduplication_keys' : IDL.Opt(IDL.Vec(IDL.Text)),
    'with_evaluation_results' : IDL.Bool,
    'expiration_from_dt' : IDL.Opt(IDL.Text),
    'tags' : IDL.Opt(IDL.Vec(IDL.Text)),
    'created_to_dt' : IDL.Opt(IDL.Text),
    'statuses' : IDL.Opt(IDL.Vec(RequestStatusCode)),
    'approver_ids' : IDL.Opt(IDL.Vec(IDL.Text)),
    'expiration_to_dt' : IDL.Opt(IDL.Text),
    'paginate' : IDL.Opt(PaginationInput_1),
    'requester_ids' : IDL.Opt(IDL.Vec(IDL.Text)),
    'operation_types' : IDL.Opt(IDL.Vec(ListRequestsOperationType)),
    'only_approvable' : IDL.Bool,
    'created_from_dt' : IDL.Opt(IDL.Text),
  });
  const ListOrbitRequestsResponse = IDL.Record({
    'total' : IDL.Nat64,
    'requests' : IDL.Vec(OrbitRequestSummary),
    'next_offset' : IDL.Opt(IDL.Nat64),
  });
  const Result_35 = IDL.Variant({
    'Ok' : ListOrbitRequestsResponse,
    'Err' : IDL.Text,
  });
  const UserStatus = IDL.Variant({
    'Inactive' : IDL.Null,
    'Active' : IDL.Null,
  });
  const UserGroup = IDL.Record({ 'id' : IDL.Text, 'name' : IDL.Text });
  const UserDTO = IDL.Record({
    'id' : IDL.Text,
    'status' : UserStatus,
    'groups' : IDL.Vec(UserGroup),
    'name' : IDL.Text,
    'last_modification_timestamp' : IDL.Text,
    'identities' : IDL.Vec(IDL.Principal),
  });
  const Result_36 = IDL.Variant({ 'Ok' : IDL.Vec(UserDTO), 'Err' : IDL.Text });
  const Result_37 = IDL.Variant({ 'Ok' : IDL.Vec(Asset), 'Err' : IDL.Text });
  const Result_38 = IDL.Variant({
    'Ok' : IDL.Vec(Permission),
    'Err' : IDL.Text,
  });
  const Result_39 = IDL.Variant({
    'Ok' : IDL.Vec(UserGroup),
    'Err' : IDL.Text,
  });
  const MonitorExternalCanisterKind = IDL.Variant({
    'Start' : MonitoringConfig,
    'Stop' : IDL.Null,
  });
  const MonitorExternalCanisterOperationInput = IDL.Record({
    'kind' : MonitorExternalCanisterKind,
    'external_canister_id' : IDL.Text,
  });
  const EnhancedSecurityDashboard = IDL.Record({
    'overall_status' : IDL.Text,
    'risk_summary' : IDL.Text,
    'station_id' : IDL.Principal,
    'checks' : IDL.Vec(SecurityCheck),
    'last_checked' : IDL.Nat64,
    'recommended_actions' : IDL.Vec(IDL.Text),
    'critical_issues' : IDL.Vec(SecurityCheck),
    'decentralization_score' : IDL.Nat8,
  });
  const Result_40 = IDL.Variant({
    'Ok' : EnhancedSecurityDashboard,
    'Err' : IDL.Text,
  });
  const PruneExternalCanisterOperationInput = IDL.Record({
    'snapshot_ids' : IDL.Vec(IDL.Text),
    'external_canister_id' : IDL.Text,
  });
  const RestoreExternalCanisterOperationInput = IDL.Record({
    'external_canister_id' : IDL.Text,
    'snapshot_id' : IDL.Text,
  });
  const SnapshotExternalCanisterOperationInput = IDL.Record({
    'force' : IDL.Bool,
    'external_canister_id' : IDL.Text,
  });
  return IDL.Service({
    'add_treasury_asset' : IDL.Func(
        [IDL.Principal, AddAssetInput],
        [Result],
        [],
      ),
    'call_orbit_canister_method_request' : IDL.Func(
        [
          IDL.Principal,
          IDL.Text,
          ExternalCanisterCallerMethodCallInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'change_orbit_canister_request' : IDL.Func(
        [
          IDL.Principal,
          ChangeExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'check_account_autoapproved_status' : IDL.Func(
        [IDL.Principal],
        [Result_2],
        [],
      ),
    'check_addressbook_injection' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_admin_control' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_asset_management' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_backend_status' : IDL.Func([IDL.Principal], [Result_3], []),
    'check_controller_manipulation' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_external_canister_calls' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_external_canisters' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_governance_permissions' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_monitoring_drain' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_named_rule_bypass' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_operational_permissions' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_proposal_policies' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_remove_operations' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_snapshot_operations' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_system_configuration' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_system_restore' : IDL.Func([IDL.Principal], [Result_2], []),
    'check_treasury_control' : IDL.Func([IDL.Principal], [Result_2], []),
    'configure_orbit_canister_request' : IDL.Func(
        [
          IDL.Principal,
          ConfigureExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'create_address_book_request' : IDL.Func(
        [CreateRequestInput],
        [CreateRequestResult],
        [],
      ),
    'create_autoapprove_all_accounts' : IDL.Func(
        [IDL.Principal],
        [Result_4],
        [],
      ),
    'create_edit_permission_request' : IDL.Func(
        [
          IDL.Principal,
          Resource,
          IDL.Opt(AuthScope),
          IDL.Opt(IDL.Vec(IDL.Text)),
          IDL.Opt(IDL.Vec(IDL.Text)),
        ],
        [Result],
        [],
      ),
    'create_equity_station' : IDL.Func([IDL.Principal], [Result_5], []),
    'create_orbit_canister_request' : IDL.Func(
        [
          IDL.Principal,
          CreateExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'create_orbit_request_with_proposal' : IDL.Func(
        [IDL.Principal, OrbitOperation],
        [Result_6],
        [],
      ),
    'create_orbit_treasury_account' : IDL.Func(
        [IDL.Principal, IDL.Text, IDL.Opt(IDL.Text)],
        [Result],
        [],
      ),
    'create_remove_admin_request' : IDL.Func(
        [IDL.Principal, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'create_remove_multiple_admins_request' : IDL.Func(
        [IDL.Principal, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        [IDL.Vec(Result)],
        [],
      ),
    'create_transfer_request' : IDL.Func(
        [
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Nat,
          IDL.Text,
          IDL.Text,
          IDL.Opt(IDL.Text),
          IDL.Principal,
        ],
        [Result],
        [],
      ),
    'create_treasury_account' : IDL.Func(
        [IDL.Principal, CreateAccountConfig],
        [Result_7],
        [],
      ),
    'edit_treasury_asset' : IDL.Func(
        [
          IDL.Principal,
          IDL.Text,
          IDL.Opt(IDL.Text),
          IDL.Opt(IDL.Vec(MetadataItem)),
        ],
        [Result],
        [],
      ),
    'ensure_proposal_for_request' : IDL.Func(
        [IDL.Principal, IDL.Text, IDL.Text],
        [Result_6],
        [],
      ),
    'fetch_orbit_account_balances' : IDL.Func(
        [IDL.Principal, IDL.Vec(IDL.Text)],
        [Result_8],
        [],
      ),
    'fund_orbit_canister_request' : IDL.Func(
        [
          IDL.Principal,
          FundExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'get_account_assets' : IDL.Func([IDL.Principal, IDL.Text], [Result_9], []),
    'get_account_icrc1_address' : IDL.Func(
        [IDL.Principal, IDL.Text],
        [Result],
        [],
      ),
    'get_account_with_assets' : IDL.Func(
        [IDL.Principal, IDL.Text],
        [Result_10],
        [],
      ),
    'get_address_book_entry' : IDL.Func(
        [GetAddressBookEntryInput],
        [GetAddressBookEntryResult],
        ['query'],
      ),
    'get_agreement_by_station' : IDL.Func(
        [IDL.Principal],
        [Result_11],
        ['query'],
      ),
    'get_agreement_snapshot' : IDL.Func(
        [IDL.Principal],
        [Result_11],
        ['query'],
      ),
    'get_all_voting_powers_for_token' : IDL.Func(
        [IDL.Principal],
        [Result_12],
        [],
      ),
    'get_available_assets' : IDL.Func([IDL.Principal], [ListAssetsResult], []),
    'get_backend_principal' : IDL.Func([], [IDL.Principal], ['query']),
    'get_canister_snapshots' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [Result_13],
        [],
      ),
    'get_canister_status' : IDL.Func([IDL.Principal], [Result_14], []),
    'get_dao_overview' : IDL.Func([IDL.Principal], [Result_15], []),
    'get_default_voting_thresholds' : IDL.Func(
        [],
        [VotingThresholds],
        ['query'],
      ),
    'get_governance_stats' : IDL.Func([IDL.Principal], [Result_16], ['query']),
    'get_high_vp_members' : IDL.Func(
        [IDL.Principal, IDL.Nat64],
        [Result_17],
        [],
      ),
    'get_kong_locker_factory_principal' : IDL.Func(
        [],
        [IDL.Principal],
        ['query'],
      ),
    'get_my_kong_locker_canister' : IDL.Func(
        [],
        [IDL.Opt(IDL.Principal)],
        ['query'],
      ),
    'get_my_locked_tokens' : IDL.Func([], [Result_18], []),
    'get_my_voting_power_for_token' : IDL.Func(
        [IDL.Principal],
        [Result_19],
        [],
      ),
    'get_orbit_canister' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [Result_20],
        [],
      ),
    'get_orbit_requests_simple' : IDL.Func([], [Result_21], []),
    'get_orbit_station_for_token' : IDL.Func(
        [IDL.Principal],
        [IDL.Opt(IDL.Principal)],
        ['query'],
      ),
    'get_orbit_system_info' : IDL.Func([IDL.Principal], [Result_22], []),
    'get_proposal_config' : IDL.Func(
        [IDL.Principal, ProposalType],
        [Result_23],
        ['query'],
      ),
    'get_request_policies_details' : IDL.Func([IDL.Principal], [Result_24], []),
    'get_station_permission' : IDL.Func(
        [IDL.Principal, Resource],
        [Result_25],
        [],
      ),
    'get_token_for_station' : IDL.Func(
        [IDL.Principal],
        [IDL.Opt(IDL.Principal)],
        ['query'],
      ),
    'get_total_voting_power_for_token' : IDL.Func(
        [IDL.Principal],
        [Result_19],
        [],
      ),
    'get_transfer_requests' : IDL.Func([IDL.Principal], [Result_4], []),
    'get_treasury_account_details' : IDL.Func(
        [IDL.Principal, IDL.Text],
        [Result_26],
        [],
      ),
    'get_treasury_accounts_with_balances' : IDL.Func(
        [IDL.Principal],
        [Result_27],
        [],
      ),
    'get_treasury_management_data' : IDL.Func([IDL.Principal], [Result_28], []),
    'get_user_pending_requests' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [Result_29],
        [],
      ),
    'get_voting_power_display' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [Result_30],
        [],
      ),
    'get_voting_thresholds' : IDL.Func([IDL.Principal], [Result_31], ['query']),
    'has_proposal_passed' : IDL.Func(
        [IDL.Principal, ProposalType, IDL.Nat64, IDL.Nat64, IDL.Nat64],
        [Result_32],
        ['query'],
      ),
    'health_check' : IDL.Func([], [IDL.Text], ['query']),
    'initialize_default_thresholds' : IDL.Func([IDL.Principal], [Result], []),
    'link_orbit_station' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [Result_5],
        [],
      ),
    'list_address_book_entries' : IDL.Func(
        [ListAddressBookEntriesInput],
        [ListAddressBookEntriesResult],
        ['query'],
      ),
    'list_all_kong_locker_registrations' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Principal))],
        ['query'],
      ),
    'list_all_locked_tokens' : IDL.Func([], [Result_18], []),
    'list_all_orbit_stations' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Principal))],
        ['query'],
      ),
    'list_orbit_accounts' : IDL.Func(
        [IDL.Principal, IDL.Text, IDL.Nat16, IDL.Nat64],
        [Result_33],
        [],
      ),
    'list_orbit_canisters' : IDL.Func(
        [IDL.Principal, ListExternalCanistersInputMinimal],
        [Result_34],
        [],
      ),
    'list_orbit_requests' : IDL.Func(
        [IDL.Principal, ListRequestsInput],
        [Result_35],
        [],
      ),
    'list_orbit_users' : IDL.Func([IDL.Principal], [Result_36], []),
    'list_station_assets' : IDL.Func([IDL.Principal], [Result_37], []),
    'list_station_permissions' : IDL.Func(
        [IDL.Principal, IDL.Opt(IDL.Vec(Resource))],
        [Result_38],
        [],
      ),
    'list_station_user_groups' : IDL.Func([IDL.Principal], [Result_39], []),
    'list_treasury_assets' : IDL.Func([IDL.Principal], [Result_37], []),
    'monitor_orbit_canister_request' : IDL.Func(
        [
          IDL.Principal,
          MonitorExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'perform_all_security_checks' : IDL.Func([IDL.Principal], [Result_2], []),
    'perform_security_check' : IDL.Func([IDL.Principal], [Result_40], []),
    'prune_orbit_canister_snapshots_request' : IDL.Func(
        [
          IDL.Principal,
          PruneExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'regenerate_agreement_snapshot' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [Result_11],
        [],
      ),
    'register_with_kong_locker' : IDL.Func([IDL.Principal], [Result], []),
    'remove_permission_from_operator_group' : IDL.Func(
        [IDL.Principal, Resource],
        [Result],
        [],
      ),
    'remove_treasury_asset' : IDL.Func([IDL.Principal, IDL.Text], [Result], []),
    'restore_orbit_canister_request' : IDL.Func(
        [
          IDL.Principal,
          RestoreExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'set_voting_thresholds' : IDL.Func(
        [IDL.Principal, VotingThresholds],
        [Result],
        [],
      ),
    'snapshot_orbit_canister_request' : IDL.Func(
        [
          IDL.Principal,
          SnapshotExternalCanisterOperationInput,
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [Result_1],
        [],
      ),
    'unregister_kong_locker' : IDL.Func([], [Result], []),
    'validate_account_name' : IDL.Func(
        [IDL.Principal, IDL.Text],
        [Result_32],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
